module.exports = __webpack_public_path__ + "static/img/xcxewm.ce0fdeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xcxewm.png
// module id = oPR3
// module chunks = 1